import React from 'react';
import { motion } from 'framer-motion';
import { Star, Palette } from 'lucide-react';
import { stripTestimonials, TESTIMONIAL_LABEL } from '../data/testimonials';
export function TestimonialsStrip() {
  return <section className="py-12 bg-sand border-y border-warmgray" data-id="element-257" data-mp="3srdaer5e0q6l">
      <div className="max-w-7xl mx-auto px-4" data-id="element-258" data-mp="3nzliodahweev">
        <h2 className="sr-only" data-id="element-259" data-mp="3nytn32gwegol">What art teachers are saying</h2>
        <div className="grid md:grid-cols-3 gap-6" data-id="element-260" data-mp="5l2sgsyf8osn">
          {stripTestimonials.map((t, i) => <motion.figure key={t.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: i * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-paper border border-warmgray p-6 rounded-2xl flex flex-col h-full" data-id="element-261" data-mp="n0y3bvjp31v" data-mpi={i}>
              <div className="flex gap-1 text-burnt mb-4" aria-label="5 out of 5 stars" data-id="element-262" data-mp="caw945qy0524">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" aria-hidden="true" data-id="element-263" data-mp="lbaxjdz7e09u" data-mpi={j} />)}
              </div>
              <blockquote className="text-charcoal-soft italic mb-6 text-sm leading-relaxed flex-grow" data-id="element-264" data-mp="102a1uct0a2nm">
                “{t.text}”
              </blockquote>
              <figcaption className="flex items-center gap-3 mt-auto" data-id="element-265" data-mp="144etj5zw8p7m">
                <div className="w-10 h-10 rounded-full bg-terracotta text-paper flex items-center justify-center shrink-0" data-id="element-266" data-mp="19389r66keubh">
                  <Palette size={18} aria-hidden="true" data-id="element-267" data-mp="35wt8bw755djt" />
                </div>
                <div data-id="element-268" data-mp="3ave8xwqb1z8s">
                  <div className="font-bold text-charcoal text-sm" data-id="element-269" data-mp="3auv0r7qgip7y">
                    {t.role}
                  </div>
                  <div className="text-xs text-terracotta-dark uppercase tracking-wider" data-id="element-270" data-mp="i1yyjae1aszm">
                    {TESTIMONIAL_LABEL}
                  </div>
                </div>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}